/* Use environment variable REACT_APP_API_BASE to allow switching to local dev backend. Falls back to http://localhost:8003 */
const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8003";

export function getApiLink(str: string): string {
    return API_BASE + str;
}